'use client';

import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeDisplayProps {
  url: string;
  size: number;
}

export default function QRCodeDisplay({ url, size }: QRCodeDisplayProps) {
  if (!url) {
    return (
      <div
        style={{ width: size, height: size }}
        className="flex items-center justify-center bg-white rounded-xl"
      >
        <div className="w-10 h-10 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="rounded-xl overflow-hidden bg-white p-2">
      <QRCodeSVG
        value={url}
        size={size - 16}
        bgColor="#ffffff"
        fgColor="#0a0f0d"
        level="M"
        imageSettings={{
          src: '/assets/images/app_logo.png',
          x: undefined,
          y: undefined,
          height: Math.round((size - 16) * 0.18),
          width: Math.round((size - 16) * 0.18),
          excavate: true,
        }}
      />
    </div>
  );
}